import Immutable from 'immutable';
import {ActionTypes} from './actions';

export const initial = Immutable.fromJS({
    loading: true,
    error: false,
    urls: {},
});

export const reducer = (state = initial, action) => {
    switch (action.type) {
        case ActionTypes.LOAD_CAPTIONS_MANIFEST:
            return state.set('loading', true);

        case ActionTypes.CAPTIONS_MANIFEST_LOADED:
            return state.set('loading', false);

        case ActionTypes.CAPTIONS_MANIFEST_FAILED:
            return state.merge({
                loading: false,
                error: true,
            });

        case ActionTypes.PARSE_CAPTIONS_MANIFEST:
            return state.mergeDeep({urls: action.urls});

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./scripts/store/captions/reducer.js